import React from "react";
import { Link } from "react-router-dom";
import {Logout} from "../Actions/Actions";
import {useTranslation} from "react-i18next";
import LanguageSwitcher from "../languageswitcher/LanguageSwitcher";
const Navigation = ({maxmenu, setMaxmenu, user}) => {
    const { t } = useTranslation();
    const handleMinMaxMenu = (e) => {
        e.preventDefault();
        setMaxmenu(!maxmenu);
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark" id="main-navbar">
            <div className="container-fluid">
                <button className="btn1 toggle-sidebar" onClick={(e) => handleMinMaxMenu(e)}>
                    <i className="bi bi-arrow-bar-left"></i>
                    <i className="bi bi-arrow-bar-right"></i>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
                        <li className="nav-item ms-2">
                            <LanguageSwitcher mode={"dropdown"}/>
                        </li>
                        {/*<li className="nav-item ms-2">*/}
                        {/*    <Link to="#" className="nav-link active py-0">*/}
                        {/*        <i className="bi bi-clock-history" style={{fontSize: "22px"}}></i>*/}
                        {/*    </Link>*/}
                        {/*</li>*/}
                        {/*<li className="nav-item ms-2">*/}
                        {/*    <Link className="nav-link active py-0" aria-current="page" to="#">*/}
                        {/*        <i className="bi bi-card-list" style={{fontSize: "26px"}}></i>*/}
                        {/*    </Link>*/}
                        {/*</li>*/}
                        <li className="nav-item dropdown ms-2">
                            <Link className="nav-link active dropdown-toggle d-flex py-0 align-items-center" to="#"
                                  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">

                                <div className="ps-2">{user.email}</div>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/">
                                        <i className="bi bi-person-lines-fill pe-3"></i>
                                        {t('profile')}
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/account">
                                        <i className="bi bi-gear pe-3"></i>
                                        {t('account')}
                                    </Link>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"/>
                                </li>
                                <li>
                                    <button type="submit" className="dropdown-item logout" onClick={Logout}>
                                        <i className="bi bi-box-arrow-left pe-3"></i>{t('exit')}
                                    </button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
export default Navigation;